var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "id": 'fullscreenNotification' + _vm.uuid
    }
  }, [_c('sweet-modal', {
    ref: _vm.uuid,
    attrs: {
      "overlay-theme": "light"
    },
    on: {
      "close": _vm.closeHandler
    }
  }, [_c('div', {
    staticClass: "slot-content",
    domProps: {
      "innerHTML": _vm._s(_vm.notifContent)
    }
  }), _vm._v(" "), (_vm.notObj.richiediConferma || _vm.notObj.eliminabile) ? _c('div', {
    staticStyle: {
      "background-color": "white",
      "border-top": "none",
      "text-align": "right"
    },
    slot: "button"
  }, [(_vm.notObj.richiediConferma) ? _c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "margin-right": "30px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.Ycallback($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.vi.Jed.firstUpperTranslate('Ok')))]) : _vm._e(), _vm._v(" "), (_vm.notObj.eliminabile) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.Ncallback($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.vi.Jed.firstUpperTranslate('Delete')))]) : _vm._e()]) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb0965c0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/modalWrapper/FullscreenNotification.vue
// module id = 1769
// module chunks = 1